(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bomb-sale"] && !Shopify.designMode) return;
  try {
    
  let timerHour = document.querySelector('.activity-timer__hour');
  let timerMin = document.querySelector('.activity-timer__min');
  let timerSecond = document.querySelector('.activity-timer__second');
  let countdownInterval = setInterval(countdown, 1000);
  function countdown() {
    let now = new Date;
    let hours = 23 - now.getHours();
    let minutes = 59 - now.getMinutes();
    let seconds = 59 - now.getSeconds();
    hours < 10 && (hours = "0" + hours),
    minutes < 10 && (minutes = "0" + minutes),
    seconds < 10 && (seconds = "0" + seconds);

    timerHour.innerHTML = `<span>${hours}</span>`;
    timerMin.innerHTML = `<span>${minutes}</span>`;
    timerSecond.innerHTML = `<span>${seconds}</span>`;
    if (hours == 0 && minutes == 0 && seconds == 0) {
      clearInterval(countdownInterval);
      countdown();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
